module.exports = __webpack_public_path__ + "img/DE02068.55ef4050.png";